import {AccionesItemDTO, IAccionesItemDTO} from "./AccionesItem.DTO";
import {Nilable} from "@shared/utils";

interface IItemPreguntaBaseDTO {
    actions: IAccionesItemDTO[];
    question_id: number;
    text: string;
    name?: Nilable<string>;
    next_question: Nilable<number>;
    link_id: Nilable<number>;
    parent_id: Nilable<number>;
    children_id: Nilable<number>;
    killer_option: Nilable<boolean>;
    conditions: Nilable<string>;
    customer_id: Nilable<string>;
    payload: any;
    checkpoint: boolean;
    align: Nilable<"T" | "B">;
    has_image: boolean;
    url: Nilable<string>;
}

export interface IItemPreguntaCargaDTO extends IItemPreguntaBaseDTO {
    id: string;
}

export interface IItemPreguntaDTO extends IItemPreguntaBaseDTO {
    id: number;
}

class ItemPreguntaBaseDTO {
    public acciones: AccionesItemDTO[] = [];
    public preguntaId = 0;
    public preguntaSiguiente: Nilable<number>;
    public padreId: Nilable<number>;
    public hijoId: Nilable<number>;
    public esOpcionKiller: Nilable<boolean>;
    public texto = "";
    public condiciones: Nilable<string>;
    public idRelativo = "";
    public clienteId: Nilable<string>;
    public payload: any = {};
    public checkpoint = false;
    public alineacion: Nilable<"T" | "B">;
    public tieneImagen = false;
    public url: Nilable<string>;

    constructor(json: Nilable<Partial<IItemPreguntaBaseDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IItemPreguntaBaseDTO>) {
        if (json.actions != null) {
            this.acciones = json.actions.map(accion => new AccionesItemDTO(accion));
        }
        if (json.question_id != null) {
            this.preguntaId = json.question_id;
        }
        if (json.next_question != null || json.link_id != null) {
            this.preguntaSiguiente = json.next_question ?? json.link_id ?? 0;
        }
        if (json.text != null) {
            this.texto = json.text;
        }
        if (json.parent_id != null) {
            this.padreId = json.parent_id;
        }
        if (json.children_id != null) {
            this.hijoId = json.children_id;
        }
        if (json.killer_option != null) {
            this.esOpcionKiller = json.killer_option;
        }
        if (json.conditions != null) {
            this.condiciones = json.conditions;
        }
        if (json.customer_id != null) {
            this.clienteId = json.customer_id;
        }
        if (json.payload != null) {
            this.payload = json.payload;
        }
        if (json.checkpoint != null) {
            this.checkpoint = json.checkpoint;
        }
        if (json.name != null) {
            this.texto = json.name;
        }
        if (json.align != null) {
            this.alineacion = json.align;
        }
        if (json.has_image != null) {
            this.tieneImagen = json.has_image;
        }
        if (json.url != null) {
            this.url = json.url;
        }
    }

    public toJSON(): IItemPreguntaBaseDTO {
        return {
            text: this.texto,
            actions: this.acciones.map(accion => accion.toJSON()),
            question_id: this.preguntaId,
            next_question: this.preguntaSiguiente,
            link_id: this.preguntaSiguiente,
            parent_id: this.padreId,
            children_id: this.hijoId,
            killer_option: this.esOpcionKiller,
            conditions: this.condiciones,
            customer_id: this.clienteId,
            payload: this.payload ?? {},
            checkpoint: this.checkpoint,
            name: this.texto,
            align: this.alineacion?.toUpperCase() as Nilable<"T" | "B">,
            has_image: this.tieneImagen,
            url: this.url
        };
    }
}

export class ItemPreguntaDTO extends ItemPreguntaBaseDTO {
    public id: number;

    constructor(json: Nilable<Partial<IItemPreguntaDTO>> = null) {
        super();

        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IItemPreguntaDTO>) {
        super.cargarDTO(json);

        if (json.id != null) {
            this.id = json.id;
        }
    }

    public toJSON(): IItemPreguntaDTO {
        return {
            ...super.toJSON(),
            id: this.id
        };
    }
}

export class ItemPreguntaCargaDTO extends ItemPreguntaBaseDTO {
    public id: string;

    constructor(json: Nilable<Partial<IItemPreguntaCargaDTO>> = null) {
        super();

        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IItemPreguntaCargaDTO>) {
        super.cargarDTO(json);

        if (json.id != null) {
            this.id = json.id;
        }
    }

    public toJSON(): IItemPreguntaCargaDTO {
        return {
            ...super.toJSON(),
            id: this.id
        };
    }
}
